import React from 'react'
import { element } from 'prop-types'
import { Grid } from '@cobalt/cobalt-react-components'
import '../../../assets/stylesheet.css'

const Wrappers = () => {}

const WrapperCenter = ({ children }) => (
  <Grid>
    <Grid.Group>
      <Grid.Column pushHcenter all="100">
        <div className="id-width-380 vertical-space">{children}</div>
      </Grid.Column>
    </Grid.Group>
  </Grid>
)

WrapperCenter.propTypes = {
  children: element.isRequired
}

Wrappers.Center = WrapperCenter

export default Wrappers
